

// // export default SettingsPage;
// import React, { useState, useEffect } from "react";
// import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
// import { Input } from "../ui/input";
// import { Button } from "../ui/button";
// import { Clock, Timer, Gauge, Settings as SettingsIcon, Mail, AlertTriangle ,Calendar} from "lucide-react";
// import PageContainer from "../Layout/PageContainer";

// const SettingsPage = () => {
//   const [settings, setSettings] = useState({
//     totalTime: "",
//     plannedBreaks: "",
//     idealRate: "",
//   });

//   const [notificationSettings, setNotificationSettings] = useState({
//     email: "",
//     defectThreshold: "",
//   });

//   const [fetchedSettings, setFetchedSettings] = useState({
//     totalTime: "",
//     plannedBreaks: "",
//     idealRate: "",
//   });

//   const [fetchedNotificationSettings, setFetchedNotificationSettings] = useState({
//     email: "",
//     defectThreshold: "",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [settingsResponse, notificationsResponse] = await Promise.all([
//           fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/settings"),
//           fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/notifications")
//         ]);

//         if (settingsResponse.ok) {
//           const data = await settingsResponse.json();
//           setFetchedSettings(data);
//         }

//         if (notificationsResponse.ok) {
//           const data = await notificationsResponse.json();
//           setFetchedNotificationSettings(data);
//         }
//       } catch (error) {
//         console.error("Error fetching settings:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleInputChange = (e, settingsType) => {
//     const { name, value } = e.target;
//     if (settingsType === 'notifications') {
//       setNotificationSettings(prev => ({ ...prev, [name]: value }));
//     } else {
//       setSettings(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSaveAll = async () => {
//     try {
//       const totalTime = settings.totalTime || fetchedSettings.totalTime;
//       const plannedBreaks = settings.plannedBreaks || fetchedSettings.plannedBreaks;
//       const idealRate = settings.idealRate || fetchedSettings.idealRate;
//       const availableTime = totalTime - plannedBreaks;
//       const email = notificationSettings.email || fetchedNotificationSettings.email;
//       const defectThreshold = notificationSettings.defectThreshold || fetchedNotificationSettings.defectThreshold;

//       const [settingsResponse, notificationsResponse] = await Promise.all([
//         fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/settings", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ totalTime, plannedBreaks, idealRate, availableTime }),
//         }),
//         fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/notifications", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ email, defectThreshold }),
//         })
//       ]);

//       if (settingsResponse.ok && notificationsResponse.ok) {
//         setFetchedSettings({ totalTime, plannedBreaks, idealRate, availableTime });
//         setFetchedNotificationSettings({ email, defectThreshold });
//         alert("All settings saved successfully!");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       alert("An error occurred while saving settings.");
//     }
//   };

//   return (
//     <PageContainer>
//       <div className="w-full p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//         <Card className="bg-slate-900/60 backdrop-blur-sm border-slate-800">
//           <CardHeader className="space-y-1">
//             <div className="flex flex-wrap items-center gap-2">
//               <SettingsIcon className="h-5 w-5 text-blue-400" />
//               <CardTitle className="text-2xl font-bold text-slate-100">OEE Settings</CardTitle>
//               <div className="flex flex-wrap gap-4 items-center text-sm text-slate-400 ml-auto p-2 bg-slate-800/60 rounded-lg">
//                 <div className="flex items-center gap-2 w-full sm:w-auto">
//                   <Clock className="h-5 w-5 text-blue-400" />
//                   <p className="text-slate-200">Scheduled Time: {fetchedSettings.availableTime ? `${fetchedSettings.availableTime} minutes` : "Not Set"}</p>
//                 </div>
//                 <div className="flex items-center gap-2 w-full sm:w-auto">
//                   <Gauge className="h-5 w-5 text-purple-400" />
//                   <p className="text-slate-200">Ideal Rate: {fetchedSettings.idealRate ? `${fetchedSettings.idealRate} units/minute` : "Not Set"}</p>
//                 </div>
//               </div>
//             </div>
//             <p className="text-sm text-slate-400">Configure your OEE calculation parameters</p>
//           </CardHeader>
//           <CardContent className="space-y-6">
//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <Clock className="h-5 w-5 text-blue-400" />
//                 <label className="text-sm font-medium text-slate-200">Total Available Time (minutes)</label>
//               </div>
//               <Input
//                 type="number"
//                 name="totalTime"
//                 value={settings.totalTime}
//                 onChange={handleInputChange}
//                 placeholder={fetchedSettings.totalTime ? `${fetchedSettings.totalTime} minutes` : "Enter total available time in minutes"}
//                 className="bg-slate-800 border-slate-700 text-slate-100  placeholder-green-500"
//               />
//               <p className="text-xs text-slate-400">Total time the machine is expected to run (e.g., 480 for 8 hours)</p>
//             </div>

//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <Timer className="h-5 w-5 text-emerald-400" />
//                 <label className="text-sm font-medium text-slate-200">Planned Breaks (minutes)</label>
//               </div>
//               <Input
//                 type="number"
//                 name="plannedBreaks"
//                 value={settings.plannedBreaks}
//                 onChange={handleInputChange}
//                 placeholder={fetchedSettings.plannedBreaks ? `${fetchedSettings.plannedBreaks} minutes` : "Enter planned break time in minutes"}
//                 className="bg-slate-800 border-slate-700 text-slate-100"
//               />
//               <p className="text-xs text-slate-400">Total planned break time including lunch, meetings, etc.</p>
//             </div>

//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <Gauge className="h-5 w-5 text-purple-400" />
//                 <label className="text-sm font-medium text-slate-200">Ideal Production Rate (units/minute)</label>
//               </div>
//               <Input
//                 type="number"
//                 name="idealRate"
//                 value={settings.idealRate}
//                 onChange={handleInputChange}
//                 placeholder={fetchedSettings.idealRate ? `${fetchedSettings.idealRate} units/minute` : "Enter ideal production rate"}
//                 className="bg-slate-800 border-slate-700 text-slate-100"
//               />
//               <p className="text-xs text-slate-400">Maximum possible production rate under ideal conditions</p>
//             </div>
//           </CardContent>
//         </Card>

//         <Card className="bg-slate-900/60 backdrop-blur-sm border-slate-800">
//           <CardHeader className="space-y-1">
//             <div className="flex items-center gap-2">
//               <Mail className="h-5 w-5 text-blue-400" />
//               <CardTitle className="text-2xl font-bold text-slate-100">Notification Settings</CardTitle>
//             </div>
//             <p className="text-sm text-slate-400">Configure notification parameters</p>
//           </CardHeader>
//           <CardContent className="space-y-6">
//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <Mail className="h-5 w-5 text-blue-400" />
//                 <label className="text-sm font-medium text-slate-200">Email Address</label>
//               </div>
//               <Input
//                 type="email"
//                 name="email"
//                 value={notificationSettings.email}
//                 onChange={(e) => handleInputChange(e, 'notifications')}
//                 placeholder={fetchedNotificationSettings.email || "Enter email address"}
//                 className="bg-slate-800 border-slate-700 text-slate-100"
//               />
//             </div>

//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <AlertTriangle className="h-5 w-5 text-yellow-400" />
//                 <label className="text-sm font-medium text-slate-200">Defect Threshold (%)</label>
//               </div>
//               <Input
//                 type="number"
//                 name="defectThreshold"
//                 value={notificationSettings.defectThreshold}
//                 onChange={(e) => handleInputChange(e, 'notifications')}
//                 placeholder={fetchedNotificationSettings.defectThreshold || "Enter defect threshold"}
//                 className="bg-slate-800 border-slate-700 text-slate-100"
//               />
//               <p className="text-xs text-slate-400">Notification will be sent when defect rate exceeds this threshold</p>
//             </div>

//             <div className="space-y-2">
//               <div className="flex items-center gap-2">
//                 <Calendar className="h-5 w-5 text-green-400" />
//                 <label className="text-sm font-medium text-slate-200">Report Frequency</label>
//               </div>
//               <select
//                 name="reportFrequency"
//                 value={notificationSettings.reportFrequency}
//                 onChange={(e) => handleInputChange(e, 'notifications')}
//                 className="w-full bg-slate-800 border-slate-700 text-slate-100 rounded-md px-3 py-2"
//               >
//                 <option value="">Select frequency</option>
//                 <option value="daily">Daily</option>
//                 <option value="weekly">Weekly</option>
//                 <option value="monthly">Monthly</option>
//               </select>
//               <p className="text-xs text-slate-400">How often you want to receive the performance report</p>
//             </div>
//           </CardContent>
//         </Card>

//         <div className="md:col-span-2">
//           <Button
//             className="w-full bg-blue-600 hover:bg-blue-700 text-white"
//             onClick={handleSaveAll}
//           >
//             <SettingsIcon className="h-4 w-4 mr-2" />
//             Save All Settings
//           </Button>
//         </div>
//       </div>
//     </PageContainer>
  
//   );
// };
import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Clock, Timer, Gauge, Settings as SettingsIcon, Mail, AlertTriangle, Calendar } from "lucide-react";
import PageContainer from "../Layout/PageContainer";

const SettingsPage = () => {
  const [settings, setSettings] = useState({
    totalTime: "",
    plannedBreaks: "",
    idealRate: "",
  });

  const [notificationSettings, setNotificationSettings] = useState({
    email: "",
    defectThreshold: "",
    reportFrequency: ""
  });

  const [fetchedSettings, setFetchedSettings] = useState({
    totalTime: "",
    plannedBreaks: "",
    idealRate: "",
  });

  const [fetchedNotificationSettings, setFetchedNotificationSettings] = useState({
    email: "",
    defectThreshold: "",
    reportFrequency: ""
  });

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      input::placeholder {
        color: #22c55e !important;
      }
      select::placeholder {
        color: #22c55e !important;
      }
      select option {
        color: white;
      }
      select option:checked {
        color: #22c55e;
      }
    `;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [settingsResponse, notificationsResponse] = await Promise.all([
          fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/settings"),
          fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/notifications")
        ]);
  
        if (settingsResponse.ok) {
          const data = await settingsResponse.json();
          setFetchedSettings(data);
        }
  
        if (notificationsResponse.ok) {
          const data = await notificationsResponse.json();
          setFetchedNotificationSettings(data);
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
  
    fetchData();
  }, []);

  const handleInputChange = (e, settingsType) => {
    const { name, value } = e.target;
    if (settingsType === 'notifications') {
      setNotificationSettings(prev => ({ ...prev, [name]: value }));
    } else {
      setSettings(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSaveAll = async () => {
    try {
      const totalTime = settings.totalTime || fetchedSettings.totalTime;
      const plannedBreaks = settings.plannedBreaks || fetchedSettings.plannedBreaks;
      const idealRate = settings.idealRate || fetchedSettings.idealRate;
      const availableTime = totalTime - plannedBreaks;
      
      const email = notificationSettings.email || fetchedNotificationSettings.email;
      const defectThreshold = notificationSettings.defectThreshold || fetchedNotificationSettings.defectThreshold;
      const reportFrequency = notificationSettings.reportFrequency || fetchedNotificationSettings.reportFrequency || 'daily';
  
      const [settingsResponse, notificationsResponse] = await Promise.all([
        fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/settings", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ totalTime, plannedBreaks, idealRate, availableTime }),
        }),
        fetch("https://3hnel2cc98.execute-api.us-east-1.amazonaws.com/notifications", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, defectThreshold, reportFrequency }),
        })
      ]);
  
      if (settingsResponse.ok && notificationsResponse.ok) {
        setFetchedSettings({ totalTime, plannedBreaks, idealRate, availableTime });
        setFetchedNotificationSettings({ email, defectThreshold, reportFrequency });
        alert("All settings saved successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving settings.");
    }
  };

  const getInputColor = (userValue, fetchedValue) => {
    if (userValue !== "") return 'white';
    return fetchedValue ? '#22c55e' : 'white';
  };

  return (
    <PageContainer>
      <div className="w-full p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="bg-slate-900/60 backdrop-blur-sm border-slate-800">
          <CardHeader className="space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <SettingsIcon className="h-5 w-5 text-blue-400" />
              <CardTitle className="text-2xl font-bold text-slate-100">OEE Settings</CardTitle>
              <div className="flex flex-wrap gap-4 items-center text-sm text-slate-400 ml-auto p-2 bg-slate-800/60 rounded-lg">
                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <Clock className="h-5 w-5 text-blue-400" />
                  <p className="text-slate-200">Scheduled Time: {fetchedSettings.availableTime ? `${fetchedSettings.availableTime} minutes` : "Not Set"}</p>
                </div>
                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <Gauge className="h-5 w-5 text-purple-400" />
                  <p className="text-slate-200">Ideal Rate: {fetchedSettings.idealRate ? `${fetchedSettings.idealRate} units/minute` : "Not Set"}</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-400">Configure your OEE calculation parameters</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Clock className="h-5 w-5 text-blue-400" />
                <label className="text-sm font-medium text-slate-200">Total Available Time (minutes)</label>
              </div>
              <Input
                type="number"
                name="totalTime"
                value={settings.totalTime || fetchedSettings.totalTime}
                onChange={handleInputChange}
                placeholder="Enter total available time in minutes"
                className="bg-slate-800 border-slate-700"
                style={{ color: getInputColor(settings.totalTime, fetchedSettings.totalTime) }}
              />
              <p className="text-xs text-slate-400">Total time the machine is expected to run (e.g., 480 for 8 hours)</p>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Timer className="h-5 w-5 text-emerald-400" />
                <label className="text-sm font-medium text-slate-200">Planned Breaks (minutes)</label>
              </div>
              <Input
                type="number"
                name="plannedBreaks"
                value={settings.plannedBreaks || fetchedSettings.plannedBreaks}
                onChange={handleInputChange}
                placeholder="Enter planned break time in minutes"
                className="bg-slate-800 border-slate-700"
                style={{ color: getInputColor(settings.plannedBreaks, fetchedSettings.plannedBreaks) }}
              />
              <p className="text-xs text-slate-400">Total planned break time including lunch, meetings, etc.</p>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Gauge className="h-5 w-5 text-purple-400" />
                <label className="text-sm font-medium text-slate-200">Ideal Production Rate (units/minute)</label>
              </div>
              <Input
                type="number"
                name="idealRate"
                value={settings.idealRate || fetchedSettings.idealRate}
                onChange={handleInputChange}
                placeholder="Enter ideal production rate"
                className="bg-slate-800 border-slate-700"
                style={{ color: getInputColor(settings.idealRate, fetchedSettings.idealRate) }}
              />
              <p className="text-xs text-slate-400">Maximum possible production rate under ideal conditions</p>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-slate-900/60 backdrop-blur-sm border-slate-800">
          <CardHeader className="space-y-1">
            <div className="flex items-center gap-2">
              <Mail className="h-5 w-5 text-blue-400" />
              <CardTitle className="text-2xl font-bold text-slate-100">Notification Settings</CardTitle>
            </div>
            <p className="text-sm text-slate-400">Configure notification parameters</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-blue-400" />
                <label className="text-sm font-medium text-slate-200">Email Address</label>
              </div>
              <Input
                type="email"
                name="email"
                value={notificationSettings.email || fetchedNotificationSettings.email}
                onChange={(e) => handleInputChange(e, 'notifications')}
                placeholder="Enter email address"
                className="bg-slate-800 border-slate-700"
                style={{ color: getInputColor(notificationSettings.email, fetchedNotificationSettings.email) }}
              />
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-yellow-400" />
                <label className="text-sm font-medium text-slate-200">Defect Threshold</label>
              </div>
              <Input
                type="number"
                name="defectThreshold"
                value={notificationSettings.defectThreshold || fetchedNotificationSettings.defectThreshold}
                onChange={(e) => handleInputChange(e, 'notifications')}
                placeholder="Enter defect threshold"
                className="bg-slate-800 border-slate-700"
                style={{ color: getInputColor(notificationSettings.defectThreshold, fetchedNotificationSettings.defectThreshold) }}
              />
              <p className="text-xs text-slate-400">Notification will be sent when defect rate exceeds this threshold</p>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Calendar className="h-5 w-5 text-green-400" />
                <label className="text-sm font-medium text-slate-200">Report Frequency</label>
              </div>
              <select
                name="reportFrequency"
                value={notificationSettings.reportFrequency || fetchedNotificationSettings.reportFrequency || ''}
                onChange={(e) => handleInputChange(e, 'notifications')}
                className="w-full bg-slate-800 border-slate-700 rounded-md px-3 py-2"
                style={{ color: getInputColor(notificationSettings.reportFrequency, fetchedNotificationSettings.reportFrequency) }}
              >
                <option value="">Select frequency</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
              <p className="text-xs text-slate-400">How often you want to receive the performance report</p>
            </div>
          </CardContent>
        </Card>

        <div className="md:col-span-2">
          <Button
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
            onClick={handleSaveAll}
          >
            <SettingsIcon className="h-4 w-4 mr-2" />
            Save All Settings
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default SettingsPage;